var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6005 24.0008H2.40034C1.07444 24.0008 0 22.9264 0 21.6014V2.40034C0 1.07444 1.07444 0 2.40034 0H21.6005C22.9264 0 24.0008 1.07444 24.0008 2.40034V21.6014C24 22.9264 22.9256 24.0008 21.6005 24.0008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5015 3.49933C19.7895 2.78727 17.6372 3.78551 16.9251 4.49756L13.3902 8.03245L4.81761 6.94024C4.45523 6.89367 4.09116 7.01813 3.83292 7.27722L2.74578 8.36435L9.36936 12.5478L6.70655 15.5383L3.87526 15.6069C3.61533 15.6128 3.49002 15.9277 3.67375 16.1115L7.88937 20.3271C8.07309 20.5108 8.38721 20.3847 8.39399 20.1256L8.46257 17.2943L11.453 14.6315L15.6365 21.2551L16.7236 20.1679C16.9819 19.9097 17.1063 19.5456 17.0606 19.1832L15.9692 10.6097L19.5041 7.07486C20.2153 6.36365 21.2136 4.21139 20.5015 3.49933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeAirplane);
export default __webpack_public_path__ + "static/media/mode-airplane.33f3691f5b8b0b3730402c4da785fcfb.svg";
export { ForwardRef as ReactComponent };